import { render, staticRenderFns } from "./ClientDetail.vue?vue&type=template&id=7c768d32"
import script from "./ClientDetail.vue?vue&type=script&lang=js"
export * from "./ClientDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports